import Component from '@glimmer/component'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import { eq } from 'ember-truth-helpers'
import type { OptionSet } from 'teacher-ui-client/components/base/checkbox-group'

type ID = string | number

interface Signature<OptionId extends ID> {
  Element: HTMLFieldSetElement
  Args: {
    listClass?: string
    checkedOptionId?: OptionId
    optionSet: OptionSet<OptionId>
    onSelectionChange: (optionSet: OptionSet<OptionId>, selectedId: OptionId) => unknown
  }
}

// Due to the way TypeScript works, it's not (currently) possible to have a generic signature for template-only
// components. That is why this is class-based.
// https://typed-ember.gitbook.io/glint/environments/ember/template-only-components
export class RadioGroup<OptionId extends ID> extends Component<Signature<OptionId>> {
  <template>
    <fieldset role="radiogroup" ...attributes>
      <legend>
        {{@optionSet.legend}}
      </legend>
      <ul class={{@listClass}}>
        {{#each @optionSet.options as |option|}}
          <li>
            <label class="inline-flex cursor-pointer items-center gap-1 font-normal select-none">
              <input
                type="radio"
                class="cursor-pointer"
                id="{{@optionSet.id}}.{{option.id}}"
                name="{{@optionSet.id}}"
                value="{{option.id}}"
                checked={{eq @checkedOptionId option.id}}
                {{on "input" (fn @onSelectionChange @optionSet option.id)}}
              />
              <span>{{option.label}}</span>
            </label>
          </li>
        {{/each}}
      </ul>
    </fieldset>
  </template>
}

export default RadioGroup
